/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/dialogs/customer-survey/app.dialogs.customer-survey.component.ts.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CustomerSurvey} from '../../models/customer-survey';
import {CustomerSurveyAnswer} from '../../models/customer-survey-answer';
import {AppMobileService} from '../../services/app.mobile.service';
import {AppCustomerSurveyService} from '../../services/app.customer-survey.service';
import {AppPageloaderService} from '../../services/app.pageloader.service';
import {AppMessageService} from '../../services/app.message.service';

/**
 * Zweck: Beschreibt class AppDialogsCustomerSurveyComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'app.dialogs.customer-survey.component.html',
    styleUrls: ['app.dialogs.customer-survey.component.scss'],
    standalone: false
})
export class AppDialogsCustomerSurveyComponent implements OnInit {
  ratings = [];

  current_rating = 0;

  current_hover_rating = null;

  hovering = false;

  valid = false;

  answer = new CustomerSurveyAnswer();

  answers = [];

  active_answers = [];

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(public dialogRef: MatDialogRef<AppDialogsCustomerSurveyComponent>,
              @Inject(MAT_DIALOG_DATA) public survey: CustomerSurvey, private svc: AppCustomerSurveyService,
              public msvc: AppMobileService, private loader: AppPageloaderService, private msg: AppMessageService) {
  }

/**
 * Beschreibt Methode change_answer und ihren Rückgabevertrag.
 */
  change_answer(idx) {
    if (!this.survey.multi_answers) {
      for (const i of Object.keys(this.answers)) {
        if (i != idx) {
          this.answers[i] = false;
        }
      }
    }

    this.active_answers = [];

    for (const i of Object.keys(this.answers)) {
      if (this.answers[i] == true) {
        this.active_answers.push(this.survey.answers[i]);
      }
    }

    this.validate();
  }

/**
 * Beschreibt Methode hoverStartStar und ihren Rückgabevertrag.
 */
  hoverStartStar(r) {
    this.hovering = true;
    this.current_hover_rating = r;
  }

/**
 * Beschreibt Methode hoverEndStar und ihren Rückgabevertrag.
 */
  hoverEndStar() {
    this.hovering = false;
    this.current_hover_rating = 0;
  }

/**
 * Beschreibt Methode setRating und ihren Rückgabevertrag.
 */
  setRating(r) {
    this.current_rating = r;
    this.validate();
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    if (this.survey.type == 'rating') {
      this.ratings = this.getRatings();
    }
  }

/**
 * Beschreibt Methode send und ihren Rückgabevertrag.
 */
  send() {
    if (this.survey.type == 'rating') {
      this.answer.answer = this.current_rating;

    } else if (this.survey.type == 'question') {
      this.answer.answer = this.active_answers;
    }

    const l = this.loader.start();
    this.svc.answer(this.survey, this.answer).subscribe(s => {
      this.msg.info('Danke vielmals!');
      l.stop();
    });

    this.dialogRef.close(true);
  }

/**
 * Beschreibt Methode validate und ihren Rückgabevertrag.
 */
  validate() {
    if (this.survey.type == 'rating' && this.current_rating > 0) {
      this.valid = true;

    } else if (this.survey.type == 'question' && this.active_answers.length > 0) {
      this.valid = true;

    } else {
      this.valid = false;
    }
  }

/**
 * Beschreibt Methode getRatings und ihren Rückgabevertrag.
 */
  getRatings() {
    const ratings = [];
    let i = 1;
    while (i <= this.survey.max_rating) {
      ratings.push(i);
      i++;
    }

    return ratings;
  }

}
